import { render, staticRenderFns } from "./RegV3.vue?vue&type=template&id=5600dc26"
import script from "./RegV3.vue?vue&type=script&lang=js"
export * from "./RegV3.vue?vue&type=script&lang=js"
import style0 from "./RegV3.vue?vue&type=style&index=0&id=5600dc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports